export default __webpack_public_path__ + "static/media/Royal Neighbors.cec1242b.svg";